class ComparisonToggle extends HTMLElement {
    connectedCallback() {
      this.toggleElements = this.querySelectorAll('[data-toggle-description]');
      this.initToggle();
      this.openFirstItem();
    }

    initToggle() {
      this.toggleElements.forEach((element) => {
        element.addEventListener('click', () => {
          const comparisonItem = element.closest('.comparison-item');
          if (comparisonItem) {
            const isActive = comparisonItem.classList.toggle('active');
            element.setAttribute('aria-expanded', isActive ? 'true' : 'false');
          }
        });
      });
    }

    openFirstItem() {
      const firstItem = this.querySelector('.comparison-item');
      if (firstItem) {
        firstItem.classList.add('active');
        const trigger = firstItem.querySelector('[data-toggle-description]');
        if (trigger) {
          trigger.setAttribute('aria-expanded', 'true');
        }
      }
    }
  }

  customElements.define('comparison-toggle', ComparisonToggle);